var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TrainerLayout',[_c('div',[_c('h3',{staticClass:"py-4 font-bold text-xl"},[_vm._v("Class History")]),_c('CourseHistoryTable',{attrs:{"data":_vm.tableData}}),(_vm.tableData.length)?_c('Pagination',{attrs:{"currentPage":_vm.currentPage,"handlePageChange":_vm.handlePageChange,"totalPages":_vm.totalPages}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }